module.exports = __webpack_public_path__ + "static/media/map-illustration.8bd9afb7.webp";